<template>
  <div class="order-dialog-view">
    <v-dialog v-model="dialog" width="1872" height="100%">
      <v-card v-if="orderData" style="height: 100%">
        <v-btn @click="dialog = false" class="mt-3" icon absolute right>
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="d-flex align-center pt-5">
          <v-card-title
            >{{ $t("requestNumberN", { number: orderData.numb }) }}
          </v-card-title>
          <div class="d-flex">
            <span
              class="d-inline-block primary--text font-weight-bold"
              v-if="orderData.state"
              :style="{ color: orderData.statusColour }"
              >{{ $t("state") }}: {{ $t(orderData.state) }}</span
            >
          </div>
        </div>
        <v-card-text style="height: 80vh; overflow: hidden">
          <!--          <viewer-window  style="height: 100%">-->
          <!--            <template #left>-->
          <div class="d-flex flex-column" style="height: 100%">
            <div
              class="order-dialog__item flex-grow-1"
              ref="orderDialogItemWrap"
              style="height: 45vh"
            >
              <div
                ref="boxRef"
                :key="boxIndex"
                v-for="(
                  /**
                   * @type Object
                   * @property MSDSFileName {string}
                   * @property productTypeName {string}
                   */
                  box,
                  boxIndex
                ) in orderData.items"
                :class="['order-dialog__item__box']"
              >
                <span
                  :class="[
                    'order-dialog__item__box__indicator',
                    {
                      'order-dialog__item__box__indicator-opened':
                        box.showDetails,
                    },
                  ]"
                >
                  <svg
                    width="12"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512"
                  >
                    <path
                      fill="currentColor"
                      d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"
                    ></path>
                  </svg>
                </span>
                <div
                  @click="toggleShowDetails(box, boxIndex)"
                  class="order-dialog__item__box__header font-weight-bold"
                >
                  <div
                    v-if="!box.isEditing"
                    class="d-flex align-center flex-grow-1"
                  >
                    <span class="d-inline-block mr-2" style="width: 50px">{{
                      box.itemNumb
                    }}</span>
                    <span
                      class="d-inline-block mr-2"
                      style="min-width: 30%; max-width: 30%"
                      >{{ box.productName }}</span
                    >
                    <span
                      class="d-inline-block mr-2 flex text-ellipsis"
                      style="text-transform: lowercase; max-width: 30%"
                      >{{ box.count }}
                      {{ box[`unit_type_name_${$i18n.locale}`] }}</span
                    >
                    <span
                      style="max-width: 30%"
                      class="d-inline-block mr-2 flex"
                      :style="{
                        textTransform: 'lowercase',
                        color: box.statusColour,
                      }"
                      >{{ $t(box.statusCode) }}
                    </span>
                  </div>
                </div>
                <div
                  class="order-dialog__item__box__details"
                  v-if="box.showDetails"
                >
                  <div class="d-flex flex-wrap">
                    <div class="d-flex col flex-wrap">
                      <div class="order-dialog__item__box__details__text col">
                        <p class="font-weight-bold mb-1">
                          {{ $t("initiator") }}
                        </p>
                        <p>{{ orderData.initiator }}</p>
                      </div>
                      <div class="order-dialog__item__box__details__text col">
                        <p class="font-weight-bold mb-1 no-wrap-text">
                          {{ $t("hasCount") }}
                        </p>
                        <p>{{ Number(box.hasProductCount) }}</p>
                      </div>
                      <div
                        class="order-dialog__item__box__details__text col"
                        v-if="box.productTypeName"
                      >
                        <p class="font-weight-bold mb-1">
                          {{ $t("categoryProduct") }}
                        </p>
                        <p>{{ box.productTypeName }}</p>
                      </div>
                      <div
                        class="order-dialog__item__box__details__text col"
                        v-if="box.contractNumber"
                      >
                        <p class="font-weight-bold mb-1">
                          {{ $t("contractNumber") }}
                        </p>
                        <p>{{ box.contractNumber }}</p>
                      </div>
                      <div
                        v-if="box.MSDSFileName"
                        class="order-dialog__item__box__details__text col-md-4"
                      >
                        <span class="no-wrap-text">{{ $t("msdsFile") }}:</span>
                        <downloader :address="box.MSDSFileName"></downloader>
                      </div>
                    </div>
                    <div class="col d-flex flex-column justify-center">
                      <div
                        class="order-dialog__item__box__details__text"
                        v-if="box.itemGuessReceiveDate"
                      >
                        <p class="font-weight-bold mb-1">
                          {{ $t("guessReceiveDate") }}
                        </p>
                        <p>
                          {{ box.itemGuessReceiveDate | fullTimeParse }}
                        </p>
                      </div>
                      <div
                        class="order-dialog__item__box__details__text"
                        v-if="box.pendingPurchaseDate"
                      >
                        <p class="font-weight-bold mb-1">
                          {{ $t("pendingPurchaseDate") }}
                        </p>
                        <p>{{ box.pendingPurchaseDate | fullTimeParse }}</p>
                      </div>
                      <div
                        class="order-dialog__item__box__details__text"
                        v-if="box.contractDate"
                      >
                        <p class="font-weight-bold mb-1">
                          {{ $t("contractDate") }}
                        </p>
                        <p>{{ box.contractDate | fullTimeParse }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="text-right">
                    <span
                      @click="box.showDetails = false"
                      class="order-dialog__item__box__details__hide-btn cursor-pointer pa-1"
                    >
                      <vue-icon
                        :class="
                          box.showDetails
                            ? 'triangle-btn'
                            : 'triangle-btn-active'
                        "
                        icon="triangleIcon"
                        style="transform: rotateY(-180deg)"
                      ></vue-icon>
                      <span class="d-inline-block ml-1">{{ $t("hide") }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <VuePagination
              @input="getOrderItems"
              v-model="page"
              :length="lastPage"
            />
            <files-wrap
              @showFile="(pages) => $refs.pdfViewer.showFile(pages)"
              class="mt-5"
              ref="fileWrap"
              :title="$t('documents')"
              :files="orderData.attachments"
            />
            <div class="files-wrap mt-5">
              <h3 class="files-wrap__title mb-2">
                {{ $t("consignmentNote") }}
              </h3>
              <p
                class="mt-1"
                v-if="
                  orderData.attachmentFiles === undefined ||
                  orderData.attachmentFiles.length === 0
                "
              >
                {{ $t("noDataAvailable") }}
              </p>
              <div
                class="d-flex flex-wrap ma-n2"
                v-if="orderData.attachmentFiles !== undefined"
              >
                <div
                  :key="`file-${fileIndex}`"
                  v-for="(file, fileIndex) in orderData.attachmentFiles"
                  class="pa-2"
                >
                  <div class="d-flex">
                    <v-btn
                      class="new_style"
                      icon
                      data-test="filesWrap-download-btn"
                    >
                      <vue-icon icon="newRequestIcon" />
                    </v-btn>
                    <div
                      class="files-wrap__box"
                      :style="{ maxWidth: 150 + 'px' }"
                    >
                      <span class="files-wrap__box__label">{{
                        file.name
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--            </template>-->
          <!--            <template #right>-->
          <!--              <pdf-viewer-->
          <!--                :canUploadFile="canUploadFile"-->
          <!--                ref="pdfViewer"-->
          <!--                :offsetBottom="230"-->
          <!--              />-->
          <!--              &lt;!&ndash;              <pdf-viewer&ndash;&gt;-->
          <!--              &lt;!&ndash;                  :canUploadFile="canUploadFile"&ndash;&gt;-->
          <!--              &lt;!&ndash;                  @upload-file="addFile"&ndash;&gt;-->
          <!--              &lt;!&ndash;                  ref="pdfViewer"/>&ndash;&gt;-->
          <!--            </template>-->
          <!--          </viewer-window>-->
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import "../order-dialog/_orderDialog.scss";
// import ViewerWindow from "@/components/ui/viewer-window/ViewerWindow";
// import PdfViewer from "@/components/pdf/PdfViewer";
import FilesWrap from "@/components/ui/files-wrap/FilesWrap";
import Downloader from "@/components/ui/downloader";
import {
  isFileDocument,
  makerPagination,
  downloadBlobFile,
} from "@/utils/pureFunctions";
import VuePagination from "@/components/ui/vue-pagination/VuePagination.vue";

const DEFAULT_ORDER_DATA = {
  id: null,
};

export default {
  name: "OrderDialogView",
  props: { canUploadFile: Boolean },
  components: {
    VuePagination,
    Downloader,
    FilesWrap,
  },
  data() {
    return {
      file: null,
      dialog: false,
      lastPage: 0,
      page: 0,
      orderData: {
        ...DEFAULT_ORDER_DATA,
        attachments: [],
        attachmentFiles: [],
        items: [],
      },
    };
  },
  methods: {
    async getOrderItems() {
      this.showLoading();
      const limit = 200;
      try {
        const {
          data: { data, total },
        } = await this.$http.get("orders/items-department", {
          params: {
            objectId: this.orderData.id,
            page: this.page - 1,
            limit,
          },
        });
        this.lastPage = makerPagination({ total, limit }).lastPage;
        this.orderData.items = this.parseItems(data);
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    toggleShowDetails(box, index) {
      const { boxRef, orderDialogItemWrap } = this.$refs;
      box.showDetails = !box.showDetails;
      this.$nextTick(() => {
        if (box.showDetails) {
          orderDialogItemWrap.scrollTop =
            orderDialogItemWrap.scrollTop +
            boxRef[index].getBoundingClientRect().top -
            orderDialogItemWrap.getBoundingClientRect().top;
        }
      });
    },
    async addFile({ file, name, tempFile }) {
      if (isFileDocument(file)) {
        this.showLoading();
        try {
          const formData = new FormData();
          formData.append("files", file);
          formData.append("orderId", this.orderData.id);
          await this.$http.post("orders/add-files", formData);
          this.orderData.attachments.push({
            isValid: true,
            name,
            file,
            tempFile,
          });
        } catch (e) {
          this.setResponseError({ error: e });
        } finally {
          this.clearLoading();
        }
      } else {
        this.setErrors({
          text: this.$t("serverErrorMessages.formatFileNotSupported"),
        });
      }
    },
    parseItems(items) {
      return items.map((item, index) => {
        return {
          ...item,
          showDetails: index === 0,
        };
      });
    },
    async downloadFile(file) {
      try {
        const { data } = await this.$http.get(`attachment/file/${file.link}`, {
          responseType: "blob",
        });
        let blob = new Blob([data], { type: "xlsx" });
        downloadBlobFile(blob, `накладной-${file.name}.xlsx`);
      } catch (err) {
        this.setResponseError({ error: err });
      } finally {
        this.clearLoading();
      }
    },
    open(data) {
      if (data) {
        this.page = data.item.itemsCurrentPage;
        this.lastPage = data.item.itemsPageCount;
        this.orderData = {
          ...data.item,
          items: this.parseItems(data.item.items),
          attachmentFiles: [],
        };
        // this.getAttachmentFiles();

        if (data.item.attachments && data.item.attachments.length) {
          setTimeout(() => {
            const { fileWrap } = this.$refs;
            if (fileWrap) {
              fileWrap.openFile(data.item.attachments[0]);
            }
          });
        }
      } else {
        this.orderData = { ...DEFAULT_ORDER_DATA, attachments: [], items: [] };
      }
      this.dialog = true;
    },
    async getAttachmentFiles() {
      try {
        const {
          data: {
            data: { attachments },
          },
        } = await this.$http.get(`/office/overhead/${this.orderData.id}`);
        this.orderData.attachmentFiles = attachments;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        const { pdfViewer } = this.$refs;
        pdfViewer.clear();
        this.orderData = { ...DEFAULT_ORDER_DATA };
        this.dialog = false;
      }
    },
  },
};
</script>
